import {
  MainBar,
  Header,
  ActionBar,
  QuickNavigation,
  AuthLayout,
  MainLayout,
  Navigation,
  PageContent,
  Sidebar,
  Wrapper,
  WrapperData,
  AdminDashboardWrapper,
} from './theme1/layout/components';

import { BarItems, MainWrapper, SidebarList, ResponsiveHideComponent } from './theme1/layout/styles';

import {
  Alert,
  confirm,
  arrayToObject,
  objectToArray,
  generateRandomColorCode,
  RenderFormGroup,
  GenerateParamsFromArray,
  ApiResponse,
} from './theme1/common/utils';

import {
  Attachment,
  AuthBoxLayout,
  NameCard,
  Button,
  Label,
  LabelInputWithIcon,
  Icon,
  BreadCrumb,
  BreadCrumbItem,
  Spinner,
  Tip,
  Chip,
  LoadMore,
  Pagination,
  ReportPagination,
  ModalTrigger,
  ModalTriggerUI,
  ActionButtons,
  EmptyState,
  Bulk,
  Filter,
  Tags,
  FilterableList,
  DropdownToggle,
  ImportFile,
  SettingTheme,
  ChooserSelector,
  FormControl,
  ControlLabel,
  FormGroup,
  Textarea,
  SelectWithSearch,
  SelectFilterAPI,
  Step,
  Steps,
  ConditionStep,
  // HorizontalSteps,
  TextDivider,
  CountsByTag,
  FilterByParams,
  Table,
  Editor,
  Tabs,
  // TabList,
  TabTitle,
  ConfirmDialog,
  DataWithLoader,
  SortableList,
  SortableListWithTwoInputs,
  ImageWithPreview,
  IntegrationIcon,
  Chooser,
  DateFilter,
  PhoneFilter,
  ModifiableSelect,
  SortHandler,
  ProjectFilter,
  AudioPlayer,
  ManageColumns,
  DashboardTheme,
  HeaderDialpad,
  OfflineDialpad,
  CallHandlerTheme,
  BardgeButton,
  PreviewButton,
  CallInboundTheme,
  CallBackNotifyTheme,
  DTMFTheme,
  CallTagTheme,
  CallInfoTheme,
  AddCallTheme,
  AddNewCallTheme,
  FAQTheme,
  ChatListTheme,
  MessageListTheme,
  OnlineScreenTheme,
  CallbackScreenTheme,
  EndCallProfileTheme,
  LiveMonitorTheme,
  LiveMonitorTheme2,
  DynamicAgTable,
  EndCallAgentProfileTheme,
  EndCallChangePwdTheme,
  CallBreakTheme,
  CallBreakSelectTheme,
  CallDashboardTheme,
  ContactProfileTheme,
  ContactInfoNoteTheme,
  ContactInfoSmartAgent,
  ContactInfoActivityTheme,
  AgentDashboardTheme,
  ContactInfoActivityTimelineTheme,
  CallPreviewLoading,
  NotificationTheme,
  CallFooterTheme,
  ReportingTheme,
  ReportFilterHeaderTheme,
  PhonenumberModalHeader,
  CommonFilter,
  ButtonCommonTheme,
  DialScreenTheme,
  SettingDropdownMenu,
  ReportingDropdownMenu,
  ContactLeftPartTheme,
  ContactRightPartTheme,
  CommonPermission,
  ContactBodyTheme,
  MenuListing,
} from './theme1/common/components';

import { APIManager } from './theme1/common/apiManager';

import {
  BoxRoot,
  FullContent,
  ModalFooter,
  InfoWrapper,
  Links,
  Well,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  CenterContent,
  ActivityContent,
  DropIcon,
  InfoWrapperP,
  ModalButtonDesign,
  SimpleButton,
  CloseModal,
  DataWrapperClass,
  Title,
  Column,
  Columns,
  OverflowClass,
  TagsStyle,
  ToggleArea,
  SkillWrapper,
  TableData,
  InsightWrapper,
  InsightFilter,
  AuthBox,
  SoundBox,
  InsightContent,
  UserAvatar,
  TimeLineStyle,
  OutBoundStyle,
  UserHeaderData,
  UserBodyData,
  ProfileDetails,
  HeadingBold,
  ModalFormContainer,
  ModalForm,
  ResponsiveBox,
  FileUploadLabel,
  SelectWrapper
} from './theme1/common/styles/main';

import {
  colors,
  dimensions,
  typography,
  // injectGlobal,
} from './theme1/common/styles';

import { SeachForm } from './theme1/common/components/form/styles';

import { StepWrapper } from './theme1/common/components/step/styles';

import {
  SortItem,
  SortableWrapper,
  DragHandler,
} from './theme1/common/styles/sort';

import {
  MainBox,
  HeaderBar,
  TopBar,
  BodyBox,
} from './theme1/common/styles/dialpadstyle';

export {
  //layout/components
  ApiResponse,
  GenerateParamsFromArray,
  MainBar,
  RenderFormGroup,
  CommonPermission,
  Header,
  ActionBar,
  AuthBoxLayout,
  QuickNavigation,
  AuthLayout,
  MainLayout,
  Navigation,
  PageContent,
  Sidebar,
  Wrapper,
  WrapperData,
  AdminDashboardWrapper,
  //layout/styles
  BarItems,
  MainWrapper,
  SidebarList,
  //common/util
  Alert,
  confirm,
  arrayToObject,
  objectToArray,
  generateRandomColorCode,
  //common/components
  SettingDropdownMenu,
  ReportingDropdownMenu,
  Attachment,
  ActionButtons,
  NameCard,
  Button,
  Label,
  LabelInputWithIcon,
  Icon,
  BreadCrumb,
  BreadCrumbItem,
  Spinner,
  Tip,
  LoadMore,
  Chip,
  Pagination,
  ProjectFilter,
  ReportPagination,
  ModalTrigger,
  ModalTriggerUI,
  EmptyState,
  Bulk,
  CountsByTag,
  Filter,
  FilterByParams,
  Tags,
  FilterableList,
  DropdownToggle,
  FormControl,
  Textarea,
  ControlLabel,
  FormGroup,
  Step,
  Steps,
  ConditionStep,
  // HorizontalSteps,
  TextDivider,
  Table,
  Editor,
  Tabs,
  // TabList,
  PhoneFilter,
  TabTitle,
  ConfirmDialog,
  DataWithLoader,
  SortableList,
  SortableListWithTwoInputs,
  ImageWithPreview,
  IntegrationIcon,
  Chooser,
  DateFilter,
  ModifiableSelect,
  SortHandler,
  SelectWithSearch,
  SelectFilterAPI,
  ChooserSelector,
  AudioPlayer,
  ImportFile,
  SettingTheme,
  ManageColumns,
  DashboardTheme,
  HeaderDialpad,
  OfflineDialpad,
  CallHandlerTheme,
  BardgeButton,
  PreviewButton,
  CallInboundTheme,
  CallBackNotifyTheme,
  DTMFTheme,
  CallTagTheme,
  CallInfoTheme,
  AddCallTheme,
  AddNewCallTheme,
  FAQTheme,
  ChatListTheme,
  MessageListTheme,
  OnlineScreenTheme,
  CallbackScreenTheme,
  EndCallProfileTheme,
  LiveMonitorTheme,
  LiveMonitorTheme2,
  DynamicAgTable,
  EndCallAgentProfileTheme,
  EndCallChangePwdTheme,
  CallBreakTheme,
  CallBreakSelectTheme,
  CallDashboardTheme,
  ContactProfileTheme,
  ContactInfoNoteTheme,
  ContactInfoSmartAgent,
  ContactInfoActivityTheme,
  AgentDashboardTheme,
  ContactInfoActivityTimelineTheme,
  CallPreviewLoading,
  NotificationTheme,
  CallFooterTheme,
  ReportingTheme,
  ReportFilterHeaderTheme,
  PhonenumberModalHeader,
  CommonFilter,
  ButtonCommonTheme,
  DialScreenTheme,
  ContactLeftPartTheme,
  ContactRightPartTheme,
  ContactBodyTheme,
  //commom/apiManager
  APIManager,
  //common/styles/main
  FileUploadLabel,
  ResponsiveBox,
  BoxRoot,
  OverflowClass,
  FullContent,
  ModalFooter,
  InfoWrapper,
  Links,
  Well,
  FormWrapper,
  FormColumn,
  ColumnTitle,
  CenterContent,
  ActivityContent,
  DropIcon,
  InfoWrapperP,
  ModalButtonDesign,
  SimpleButton,
  CloseModal,
  DataWrapperClass,
  Title,
  Column,
  Columns,
  TagsStyle,
  ToggleArea,
  SkillWrapper,
  TableData,
  InsightWrapper,
  InsightFilter,
  AuthBox,
  SoundBox,
  InsightContent,
  UserAvatar,
  TimeLineStyle,
  OutBoundStyle,
  UserHeaderData,
  UserBodyData,
  ProfileDetails,
  HeadingBold,
  SelectWrapper,
  //common/styles
  colors,
  dimensions,
  typography,
  // injectGlobal,
  //commom/componnents/form/styles
  SeachForm,
  // common/components/sort/styles
  StepWrapper,
  //common/styles/sort
  SortItem,
  SortableWrapper,
  DragHandler,
  //common/styles/dialpadstyles
  MainBox,
  HeaderBar,
  TopBar,
  BodyBox,
  MenuListing,
  ModalFormContainer,
  ModalForm,
  ResponsiveHideComponent
};

export const app_theme = 'tcc';



// WEBPACK FOOTER //
// src/modules/theme/index.js